import ResumeTips from "./ResumeTips";

export default ResumeTips;
